/* Models */
import { Page } from '../models';

/* ActionTypes */
import { PAGE_ENTITY_ACTION_TYPES } from './actionTypes';

/* Utils */
import { generateEntityReducer } from '../utils/generators/reducerGenerators';

const pagesReducer = generateEntityReducer(PAGE_ENTITY_ACTION_TYPES, Page);

export default pagesReducer;
